var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2349_6705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22V16H0",
    fill: "#B31942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 13.4545V14.6666H0V13.4545H22ZM22 11.0302V12.2423H0V11.0302H22ZM22 8.60598V9.8181H0V8.60598H22ZM22 6.18174V7.39386H0V6.18174H22ZM22 3.75749V4.96962H0V3.75749H22ZM22 1.33325V2.54537H0V1.33325H22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.10352e-05 0H12.6499V8.61538H-6.10352e-05",
    fill: "#0A3161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0541 0.369385L1.35513 1.25998L0.567017 0.709561H1.54118L0.753064 1.25998L1.0541 0.369385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0541 2.09253L1.35513 2.98312L0.567017 2.43271H1.54118L0.753064 2.98312L1.0541 2.09253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0541 3.81543L1.35513 4.70602L0.567017 4.15561H1.54118L0.753064 4.70602L1.0541 3.81543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0541 5.53857L1.35513 6.42917L0.567017 5.87875H1.54118L0.753064 6.42917L1.0541 5.53857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0541 7.26172L1.35513 8.15231L0.567017 7.6019H1.54118L0.753064 8.15231L1.0541 7.26172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1083 1.23096L2.40933 2.12155L1.62122 1.57113H2.59537L1.80726 2.12155L2.1083 1.23096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1083 2.9541L2.40933 3.84469L1.62122 3.29428H2.59537L1.80726 3.84469L2.1083 2.9541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1083 4.677L2.40933 5.56759L1.62122 5.01718H2.59537L1.80726 5.56759L2.1083 4.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1083 6.40015L2.40933 7.29074L1.62122 6.74032H2.59537L1.80726 7.29074L2.1083 6.40015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16249 0.369385L3.46353 1.25998L2.67542 0.709561H3.64957L2.86146 1.25998L3.16249 0.369385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16249 2.09253L3.46353 2.98312L2.67542 2.43271H3.64957L2.86146 2.98312L3.16249 2.09253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16249 3.81543L3.46353 4.70602L2.67542 4.15561H3.64957L2.86146 4.70602L3.16249 3.81543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16249 5.53857L3.46353 6.42917L2.67542 5.87875H3.64957L2.86146 6.42917L3.16249 5.53857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16249 7.26172L3.46353 8.15231L2.67542 7.6019H3.64957L2.86146 8.15231L3.16249 7.26172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21669 1.23096L4.51773 2.12155L3.72961 1.57113H4.70377L3.91566 2.12155L4.21669 1.23096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21663 2.9541L4.51766 3.84469L3.72955 3.29428H4.70371L3.9156 3.84469L4.21663 2.9541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21663 4.677L4.51766 5.56759L3.72955 5.01718H4.70371L3.9156 5.56759L4.21663 4.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21663 6.40015L4.51766 7.29074L3.72955 6.74032H4.70371L3.9156 7.29074L4.21663 6.40015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27083 0.369385L5.57186 1.25998L4.78375 0.709561H5.75791L4.9698 1.25998L5.27083 0.369385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27077 2.09253L5.5718 2.98312L4.78369 2.43271H5.75785L4.96974 2.98312L5.27077 2.09253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27077 3.81543L5.5718 4.70602L4.78369 4.15561H5.75785L4.96974 4.70602L5.27077 3.81543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27077 5.53857L5.5718 6.42917L4.78369 5.87875H5.75785L4.96974 6.42917L5.27077 5.53857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27077 7.26172L5.5718 8.15231L4.78369 7.6019H5.75785L4.96974 8.15231L5.27077 7.26172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32497 1.23096L6.626 2.12155L5.83789 1.57113H6.81205L6.02394 2.12155L6.32497 1.23096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32497 2.9541L6.626 3.84469L5.83789 3.29428H6.81205L6.02394 3.84469L6.32497 2.9541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32497 4.677L6.626 5.56759L5.83789 5.01718H6.81205L6.02394 5.56759L6.32497 4.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32497 6.40015L6.626 7.29074L5.83789 6.74032H6.81205L6.02394 7.29074L6.32497 6.40015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37911 0.369385L7.68014 1.25998L6.89203 0.709561H7.86619L7.07808 1.25998L7.37911 0.369385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37911 2.09253L7.68014 2.98312L6.89203 2.43271H7.86619L7.07808 2.98312L7.37911 2.09253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37911 3.81543L7.68014 4.70602L6.89203 4.15561H7.86619L7.07808 4.70602L7.37911 3.81543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37911 5.53857L7.68014 6.42917L6.89203 5.87875H7.86619L7.07808 6.42917L7.37911 5.53857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37911 7.26172L7.68014 8.15231L6.89203 7.6019H7.86619L7.07808 8.15231L7.37911 7.26172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43331 1.23096L8.73434 2.12155L7.94623 1.57113H8.92039L8.13228 2.12155L8.43331 1.23096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43331 2.9541L8.73434 3.84469L7.94623 3.29428H8.92039L8.13228 3.84469L8.43331 2.9541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43331 4.677L8.73434 5.56759L7.94623 5.01718H8.92039L8.13228 5.56759L8.43331 4.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43331 6.40015L8.73434 7.29074L7.94623 6.74032H8.92039L8.13228 7.29074L8.43331 6.40015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48751 0.369385L9.78854 1.25998L9.00043 0.709561H9.97459L9.18648 1.25998L9.48751 0.369385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48751 2.09253L9.78854 2.98312L9.00043 2.43271H9.97459L9.18648 2.98312L9.48751 2.09253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48751 3.81543L9.78854 4.70602L9.00043 4.15561H9.97459L9.18648 4.70602L9.48751 3.81543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48751 5.53857L9.78854 6.42917L9.00043 5.87875H9.97459L9.18648 6.42917L9.48751 5.53857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48751 7.26172L9.78854 8.15231L9.00043 7.6019H9.97459L9.18648 8.15231L9.48751 7.26172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5417 1.23096L10.8427 2.12155L10.0546 1.57113H11.0288L10.2407 2.12155L10.5417 1.23096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5417 2.9541L10.8427 3.84469L10.0546 3.29428H11.0288L10.2407 3.84469L10.5417 2.9541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5417 4.677L10.8427 5.56759L10.0546 5.01718H11.0288L10.2407 5.56759L10.5417 4.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5417 6.40015L10.8427 7.29074L10.0546 6.74032H11.0288L10.2407 7.29074L10.5417 6.40015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5958 0.369385L11.8969 1.25998L11.1088 0.709561H12.0829L11.2948 1.25998L11.5958 0.369385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5958 2.09253L11.8969 2.98312L11.1088 2.43271H12.0829L11.2948 2.98312L11.5958 2.09253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5958 3.81543L11.8969 4.70602L11.1088 4.15561H12.0829L11.2948 4.70602L11.5958 3.81543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5958 5.53857L11.8969 6.42917L11.1088 5.87875H12.0829L11.2948 6.42917L11.5958 5.53857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5958 7.26172L11.8969 8.15231L11.1088 7.6019H12.0829L11.2948 8.15231L11.5958 7.26172Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2349_6705"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H20C21.1046 0 22 0.895431 22 2V14C22 15.1046 21.1046 16 20 16H2C0.89543 16 0 15.1046 0 14V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/us_flag.78b32fe84fc17ebcdca535d1603408f8.svg";
export { ForwardRef as ReactComponent };